module.exports = __webpack_public_path__ + "static/media/ninth_newpaper_plant3.95ee97e5.jpg";